import './IncrementalityTestKpi.scss';

import cn from 'classnames';
import { MdDelete } from 'react-icons/md';
import { Form } from 'react-bootstrap';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { IncrementalityTestKpi } from './OfflineInputsUtils';

interface IncrementalityTestKpiComponentProps {
  index: number;
  kpi: IncrementalityTestKpi;
  updateKpi: (uuid: string, value: string) => void;
  deleteKpi: (uuid: string, name: string) => void;
}

export const IncrementalityTestKpiComponent = ({
  index,
  kpi,
  updateKpi,
  deleteKpi
}: IncrementalityTestKpiComponentProps) => (
  <div className={cn('kpi', { 'first-kpi': index === 0 })}>
    <div className='kpi-name-label'>
      <div className='kpi-name-title'>KPI Name {index + 1}</div>
    </div>
    <div className='kpi-name-input'>
      <Form.Control
        placeholder='Ex: Purchases'
        value={kpi.name}
        onChange={e => updateKpi(kpi.uuid, e.target.value)}
      />
    </div>
    {index > 0 && (
      <InteractiveDiv className='delete-icon' onClick={() => deleteKpi(kpi.uuid, kpi.name)}>
        <MdDelete />
      </InteractiveDiv>
    )}
  </div>
);
